import { Component, Input, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Subscription } from "rxjs";
import { LaunchDarklyService } from "../../launchDarkly/launchDarkly.service";
import { KpiService } from "../../kpi/kpi.service";
import { TopNavBtn, TopNavDropdownItem } from "../../classes/navbar";

import { environment } from "../../../environments/environment";
import { Router, NavigationEnd } from "@angular/router";
import { head, split } from "lodash";
import { STAND_CUSTOMER_ID } from "../../constants";
import * as Constants from "../../constants";

@Component({
  selector: "navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
  @Input()
  title;

  hideFrozenEnrollment = [9999, 114964, 174346, 183169, 183172, 188029]; //Customer ids to hide frozen enrollment message for
  hasFrozenEnrollment: boolean;
  isMobile: boolean;
  hostname = `${environment.szAppHostname}`;
  isTeacher: boolean;
  isAdmin: boolean;
  isSchoolLeader: boolean;
  isRestrictedUser: boolean = true;
  isStarterUser: boolean;
  hasDataWall: boolean;
  currentPage: string;
  topNavBtns: Array<TopNavBtn>;
  hamburgerDropdownItems: Array<TopNavDropdownItem>;
  role: string;
  tier: string;
  rgpTenantId: string;
  isMultiCustUser: boolean;
  isResumeRole: boolean;
  flagSubscription: Subscription;
  showOurSchoolsNavLink: boolean = false;
  loading: boolean = true;

  constructor(
    public kpiService: KpiService,
    private titleService: Title,
    public router: Router,
    public launchDarklyService: LaunchDarklyService
  ) {
    this.flagSubscription = launchDarklyService.flagChange.subscribe(() =>
      this.initFlags(launchDarklyService)
    );
  }

  ngOnInit() {
    this.router.events.subscribe((routeObj: any) => {
      if (routeObj && routeObj.url && routeObj instanceof NavigationEnd) {
        //Compare the old and new URLs (minus query string) to determine if this counts as a new pageview to be tracked
        let newPageView = this.currentPage
          ? head(split(this.currentPage, "?", 1)) !=
            head(split(routeObj.url, "?", 1))
          : true;

        this.currentPage = routeObj.url;
        this.kpiService.setCurrentPage(this.currentPage);
        this.setPageTitle(newPageView);
      }
    });
    this.isMobile = window.innerWidth < 992;
    this.kpiService.getUserInfo().subscribe(
      (data) => {
        this.loading = false;
        this.isResumeRole = data.resume_role == "true";
        this.rgpTenantId = data.rgp_tenant;
        this.role = data.role;
        this.tier = data.sz_tier;
        this.isAdmin = data.role == "admin";
        this.isSchoolLeader = data.role == "school_leader";
        this.isRestrictedUser = data.role == "restricted_user";
        this.isTeacher = data.role == "teacher";
        this.isStarterUser = data.sz_tier == "starter";
        this.hasFrozenEnrollment =
          this.hideFrozenEnrollment.indexOf(data.organizationId) == -1 &&
          data.has_frozen_enrollment &&
          data.has_frozen_enrollment == "true";
        this.isMultiCustUser =
          data.user_customers && data.user_customers.length > 1;
        this.topNavBtns = []; //leaving this empty as it will break in another piece of code otherwise
        this.hamburgerDropdownItems = [
          new TopNavDropdownItem(
            "Data Configuration Settings",
            "/data-configuration/settings/",
            true,
            true,
            true,
            false,
            null,
            null,
            false,
            "Nav.Mobile.Dropdown.DataConfigSettings"
          ),
          new TopNavDropdownItem(
            "Metric Settings",
            "/metric/settings/",
            true,
            true,
            true,
            false,
            null,
            null,
            false,
            "Nav.Mobile.Dropdown.MetricSettings"
          ),
        ];
        if (!this.isStarterUser) {
          this.hamburgerDropdownItems = [
            ...this.hamburgerDropdownItems,
            new TopNavDropdownItem(
              "My Data",
              this.hostname + "/s/mydata",
              false,
              true,
              true,
              false,
              null,
              null,
              true,
              "Nav.Mobile.Dropdown.MyData"
            ),
            new TopNavDropdownItem(
              "My Schools",
              this.hostname + "/s/schoolSettings",
              false,
              true,
              true,
              false,
              null,
              null,
              true,
              "Nav.Mobile.Dropdown.MySchools"
            ),
            new TopNavDropdownItem(
              "My Users",
              this.hostname + "/share",
              false,
              true,
              true,
              false,
              null,
              null,
              true,
              "Nav.Mobile.Dropdown.MyUsers"
            ),
          ];
        }
        if (data.other_reports_url) {
          this.topNavBtns = [
            ...this.topNavBtns,
            new TopNavBtn(
              data.other_reports_label
                ? data.other_reports_label
                : "Other Reports",
              "custom_navbar_grid_arrow.svg",
              "",
              false,
              false,
              true,
              false,
              false,
              null,
              data.other_reports_url,
              null,
              "Nav.OtherReports"
            ),
          ];
          this.hamburgerDropdownItems = [
            ...this.hamburgerDropdownItems,
            new TopNavDropdownItem(
              data.other_reports_label
                ? data.other_reports_label
                : "Other Reports",
              "",
              false,
              false,
              true,
              false,
              data.other_reports_url,
              null,
              false,
              "Nav.Mobile.Dropdown.OtherReports"
            ),
          ];
        }
        if (data.ninth_grade_success_url) {
          this.topNavBtns = [
            ...this.topNavBtns,
            new TopNavBtn(
              data.ninth_grade_success_label
                ? data.ninth_grade_success_label
                : "Ninth Grade Success",
              "star.svg",
              "",
              false,
              false,
              true,
              false,
              false,
              null,
              null,
              data.ninth_grade_success_url,
              "Nav.NinthGradeSuccess"
            ),
          ];
          this.hamburgerDropdownItems = [
            ...this.hamburgerDropdownItems,
            new TopNavDropdownItem(
              data.ninth_grade_success_label
                ? data.ninth_grade_success_label
                : "Ninth Grade Success",
              "",
              false,
              false,
              true,
              false,
              null,
              data.ninth_grade_success_url,
              false,
              "Nav.Mobile.Dropdown.NinthGradeSuccess"
            ),
          ];
        }

        let settingsDropdown = [
          new TopNavDropdownItem(
            "Data Configuration Settings",
            "/data-configuration/settings/",
            true,
            true,
            true,
            false,
            null,
            null,
            null,
            "Nav.Dropdown.DataConfigSettings"
          ),
          new TopNavDropdownItem(
            "Metric Settings",
            "/metric/settings/",
            true,
            true,
            true,
            false,
            null,
            null,
            null,
            "Nav.Dropdown.MetricSettings"
          ),
        ];
        if (!this.isStarterUser) {
          //If starter user, don't show "my data", "my schools" and "my users" options.
          settingsDropdown = [
            ...settingsDropdown,
            new TopNavDropdownItem(
              "My Data",
              this.hostname + "/s/mydata",
              false,
              true,
              true,
              false,
              null,
              null,
              null,
              "Nav.Dropdown.MyData"
            ),
            new TopNavDropdownItem(
              "My Schools",
              this.hostname + "/s/schoolSettings",
              false,
              true,
              true,
              false,
              null,
              null,
              null,
              "Nav.Dropdown.MySchools"
            ),
            new TopNavDropdownItem(
              "My Users",
              this.hostname + "/share",
              false,
              true,
              true,
              false,
              null,
              null,
              null,
              "Nav.Dropdown.MyUsers"
            ),
          ];
        }
        let supportDropdown;
        if (!this.isStarterUser) {
          supportDropdown = [
            new TopNavDropdownItem(
              "Contact Support",
              "https://illuminate.zendesk.com/hc/en-us/requests/new?ticket_form_id=21621854042395",
              false,
              false,
              false,
              false,
              null,
              null,
              true,
              "Nav.Dropdown.Support"
            ),
            new TopNavDropdownItem(
              "Schoolzilla Help Center",
              Constants.HELP_URLS.HELP_CENTER_NONSTARTER_URL,
              false,
              false,
              false,
              false,
              null,
              null,
              true,
              "Nav.Dropdown.SZHelpCenter"
            ),
          ];
        } else {
          supportDropdown = [
            new TopNavDropdownItem(
              "Help Documentation",
              Constants.HELP_URLS.HELP_CENTER_STARTER_URL,
              false,
              false,
              false,
              false,
              null,
              null,
              null,
              "Nav.Dropdown.RLSupport"
            ),
            new TopNavDropdownItem(
              "Live Chat",
              "",
              false,
              false,
              false,
              false,
              null,
              null,
              null,
              "Nav.Dropdown.LiveChat"
            ),
          ];
        }
        this.topNavBtns = [
          ...this.topNavBtns,
          new TopNavBtn(
            "Settings",
            "settings_icon.svg",
            null,
            false,
            true,
            true,
            false,
            false,
            settingsDropdown,
            null,
            null,
            "Nav.Settings"
          ),
          new TopNavBtn(
            "Help",
            "support_icon.svg",
            null,
            false,
            false,
            false,
            false,
            false,
            supportDropdown,
            null,
            null,
            "Nav.Support"
          ),
        ];

        if (!this.isStarterUser) {
          this.hamburgerDropdownItems = [
            ...this.hamburgerDropdownItems,
            new TopNavDropdownItem(
              "Contact Support",
              "https://illuminate.zendesk.com/hc/en-us/requests/new?ticket_form_id=21621854042395",
              false,
              false,
              false,
              false,
              null,
              null,
              true,
              "Nav.Mobile.Dropdown.Support"
            ),
            new TopNavDropdownItem(
              "Schoolzilla Help Center",
              Constants.HELP_URLS.HELP_CENTER_NONSTARTER_URL,
              false,
              false,
              false,
              false,
              null,
              null,
              true,
              "Nav.Mobile.Dropdown.SZHelpCenter"
            ),
          ];
        } else {
          this.hamburgerDropdownItems = [
            ...this.hamburgerDropdownItems,
            new TopNavDropdownItem(
              "Help Documentation",
              Constants.HELP_URLS.HELP_CENTER_STARTER_URL,
              false,
              false,
              false,
              false,
              null,
              null,
              true,
              "Nav.Mobile.Dropdown.RLSupport"
            ),
            new TopNavDropdownItem(
              "Live Chat",
              "",
              false,
              false,
              false,
              false,
              null,
              null,
              null,
              "Nav.Dropdown.LiveChat"
            ),
          ];
        }

        let leaveSZDropdown;
        if (this.isMultiCustUser) {
          // create dropdown to be displayed under Exit/Logout
          const title = this.isResumeRole ? "Resume Role" : "Switch Accounts";
          const url =
            this.hostname +
            (this.isResumeRole ? "/resume-role" : "/select-customer");
          leaveSZDropdown = [
            new TopNavDropdownItem(
              title,
              url,
              false,
              false,
              false,
              false,
              null,
              null,
              false,
              "Nav.Dropdown.SwitchAccounts"
            ),
            new TopNavDropdownItem(
              this.isStarterUser ? "Exit" : "Logout",
              this.hostname + "/logout",
              false,
              false,
              false,
              false,
              null,
              null,
              false,
              "Nav.Dropdown.Logout"
            ),
          ];
          // add "Resume Role/Switch Accounts" to the mobile hamburger dropdown
          this.hamburgerDropdownItems = [
            ...this.hamburgerDropdownItems,
            new TopNavDropdownItem(
              title,
              url,
              false,
              false,
              false,
              false,
              null,
              null,
              false,
              "Nav.Mobile.Dropdown.SwitchAccounts"
            ),
          ];
        }

        this.topNavBtns = [
          ...this.topNavBtns,
          new TopNavBtn(
            this.isStarterUser ? "Exit" : "Logout",
            "logout.svg",
            this.isMultiCustUser ? null : this.hostname + "/logout",
            false,
            false,
            false,
            false,
            false,
            this.isMultiCustUser ? leaveSZDropdown : null,
            null,
            null,
            "Nav.Logout"
          ),
        ];

        // add "Exit/Logout" to the mobile hamburger dropdown
        this.hamburgerDropdownItems = [
          ...this.hamburgerDropdownItems,
          new TopNavDropdownItem(
            this.isStarterUser ? "Exit" : "Logout",
            this.hostname + "/logout",
            false,
            false,
            false,
            false,
            null,
            null,
            false,
            "Nav.Mobile.Dropdown.Logout"
          ),
        ];
      },
      (error) => {
        this.loading = false;
        console.error(error);
      }
    );
  }

  initFlags(launchDarklyService: LaunchDarklyService) {
    this.showOurSchoolsNavLink = launchDarklyService.getFlag(
      "our-schools-nav-link"
    );
  }

  setPageTitle(newPageView: boolean) {
    let eventType = "";
    if (this.currentPage == "/") {
      this.titleService.setTitle("District Profile");
      eventType = "mosaic.pageview.district.profile";
    } else if (this.currentPage.includes("/comparison/school")) {
      this.titleService.setTitle("School Comparison");
      eventType = "mosaic.pageview.our.schools";
    } else if (this.currentPage.includes("/profile/school")) {
      this.titleService.setTitle("School Profile");
      eventType = "mosaic.pageview.school.profile";
    } else if (this.currentPage.includes("/comparison/student")) {
      this.titleService.setTitle("Student Comparison");
      eventType = "mosaic.pageview.our.students";
    } else if (this.currentPage.includes("/profile/student")) {
      this.titleService.setTitle("Student Profile");
      eventType = "mosaic.pageview.student.profile";
    } else if (this.currentPage.includes("/usage")) {
      this.titleService.setTitle("Usage Profile");
      eventType = "mosaic.pageview.usage.profile";
    } else if (this.currentPage.includes("/data-configuration/settings")) {
      this.titleService.setTitle("Data Configuration Settings");
      eventType = "mosaic.pageview.data.configuration.settings";
    } else if (this.currentPage.includes("/metric/settings")) {
      this.titleService.setTitle("Metric Settings");
      eventType = "mosaic.pageview.metric.settings";
    } else {
      this.isStarterUser
        ? this.titleService.setTitle("Renaissance Analytics")
        : this.titleService.setTitle("Schoolzilla");
    }
    //Exclude "/profile/student" since that will redirect to a specific student profile immediately after
    if (
      newPageView &&
      eventType != "" &&
      this.currentPage != "/profile/student"
    ) {
      this.kpiService.trackEvent(eventType).subscribe();
    }
  }
}
